import { calculatePriceAfterPromoCodeAndDTP } from '@/helpers/checkoutHelpers/calculatePriceAfterPromoCodeAndDTP'
import type { StandardLineItem, PropagatedLineItemFields } from '@/types/ShopFront/CheckoutStandards'
import { standardizeProductName } from './standardizeProductName'
import { standardizeProductOption } from './standardizeProductOption'

export type lineItemStandardizerInput = {
  name: string,
  options: Array<{
    name: string
    value: string
    // nameId: number
    // valueId: number
  }>
  extendedListPrice: number,
  discounts: Array<{
    discountedAmount: number
    id: string
  }>
  isFreeShipping: boolean
} & PropagatedLineItemFields

export type lineItemStandardizer = (input: lineItemStandardizerInput) => StandardLineItem

export const standardizeLineItem: lineItemStandardizer = ({
  name,
  options = [],
  discounts,
  extendedListPrice,
  listPrice,
  ...rest
}) => ({
  name: standardizeProductName(name, options),
  originalName: name,
  options: options.map(standardizeProductOption),
  salePriceAfterDiscount: calculatePriceAfterPromoCodeAndDTP({
    extendedListPrice,
    discounts,
  }),
  subtotalPrice: listPrice,
  listPrice,
  extendedListPrice,
  discounts,
  ...rest,
})
